import PropTypes from "prop-types";
import StatusPill from "../theme/components/StatusPill.jsx";

// Map backend claim status values to the theme's Chip variant names.
const statusVariantMap = {
  saved: "claim-status-gespeichert",
  draft: "claim-status-entwurf",
  pre_check: "claim-status-pruefung",
  correction_customer: "claim-status-korrektur",
  correction_insurer: "claim-status-korrektur",
  processing: "claim-status-bearbeitung",
  released: "claim-status-bearbeitung",
  settled: "claim-status-abgeschlossen",
  partial_settled: "claim-status-teilreguliert",
  closed: "claim-status-abgeschlossen",
  closed_below_threshold: "claim-status-abgeschlossen",
  rejected: "claim-status-abgelehnt",
};

/**
 * Status badge for claim statuses — a thin domain wrapper around StatusPill
 * that maps a backend status value to the matching theme Chip variant.
 *
 * @param {Object} props
 * @param {string} props.status - The status value (e.g., 'saved', 'pre_check', 'processing')
 * @param {string} props.label - The display label for the status
 * @param {string} props.size - Size of the chip ('tiny' | 'small' | 'medium')
 * @param {function} [props.onClick] - Optional click handler for the badge
 * @param {boolean} [props.open] - Whether the badge is in an "open" state (for dropdown indicators)
 * @param {boolean} [props.disabled] - Whether the badge is disabled
 * @returns {JSX.Element}
 */
const ClaimStatusBadge = ({
  status,
  label,
  size = "small",
  onClick,
  open = false,
  disabled = false,
  ariaLabelledby,
}) => {
  const variant = statusVariantMap[status] || "claim-status-gespeichert";

  return (
    <StatusPill
      variant={variant}
      label={label}
      size={size}
      onClick={onClick}
      open={open}
      disabled={disabled}
      ariaLabelledby={ariaLabelledby}
    />
  );
};

ClaimStatusBadge.propTypes = {
  status: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  size: PropTypes.oneOf(["tiny", "small", "medium"]),
  onClick: PropTypes.func,
  open: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default ClaimStatusBadge;
